var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sys"},[_vm._m(0),_c('div',{staticClass:"ql-editor",staticStyle:{"width":"100%"},domProps:{"innerHTML":_vm._s(decodeURIComponent(_vm.content))}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('img',{staticStyle:{"width":"130px"},attrs:{"src":require("@/assets/image/wra.png"),"alt":""}})])
}]

export { render, staticRenderFns }